// src/redux/actions/chatActions.ts
import { createAction } from '@reduxjs/toolkit';

// Action types (legacy)
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const NEW_MESSAGE_RECEIVED = 'NEW_MESSAGE_RECEIVED';
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT';
export const SET_SOCKET_CONNECTIVITY = 'SET_SOCKET_CONNECTIVITY';
export const SET_SOCKET_INSTANCE = 'SET_SOCKET_INSTANCE';
export const ENGAGEMENT_CREATED = 'ENGAGEMENT_CREATED';

// Action creators (legacy)
export const setSocketConnectivity = createAction<any>('SET_SOCKET_CONNECTIVITY');
export const setSocketInstance = createAction<any>('SET_SOCKET_INSTANCE');
export const addParticipant = createAction<any>('ADD_PARTICIPANT');
export const removeParticipant = createAction<any>('REMOVE_PARTICIPANT');
export const newMessageReceived = createAction<any>('NEW_MESSAGE_RECEIVED');
export const engagementCreated = createAction<any>('ENGAGEMENT_CREATED');

// Bridge actions for Twilio migration: mirror Twilio client/conversation and data into legacy chat slice
export const setTwilioConversation = createAction<any>('SET_TWILIO_CONVERSATION');
export const setTwilioClient = createAction<any>('SET_TWILIO_CLIENT');
export const setTwilioMessages = createAction<any>('SET_TWILIO_MESSAGES');
export const addTwilioMessage = createAction<any>('ADD_TWILIO_MESSAGE');
export const setTwilioParticipants = createAction<any>('SET_TWILIO_PARTICIPANTS');
export const updateTwilioParticipant = createAction<any>('UPDATE_TWILIO_PARTICIPANT');
export const removeTwilioParticipant = createAction<any>('REMOVE_TWILIO_PARTICIPANT');
export const setTwilioUsers = createAction<any>('SET_TWILIO_USERS');
export const updateTwilioMessage = createAction<any>('UPDATE_TWILIO_MESSAGE');
export const removeTwilioMessage = createAction<any>('REMOVE_TWILIO_MESSAGE');

